export function Cookies() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold tracking-tight">Politica de cookies</h1>
      <p className="mt-2 text-sm text-text-tertiary">
        Ultima actualizacion: 25/04/2026 — Borrador inicial.
      </p>

      <div className="mt-8 space-y-6 text-text-secondary">
        <p>
          ExamsReactor utiliza la cantidad <strong>minima posible</strong> de cookies y tecnologias
          similares. Nuestro analytics (Plausible) es privacy-friendly y no usa cookies cross-site.
        </p>

        <h2 className="text-2xl font-bold">Cookies que usamos</h2>

        <table className="w-full text-sm">
          <thead className="border-b border-border-subtle">
            <tr>
              <th className="py-2 text-left">Nombre</th>
              <th className="py-2 text-left">Tipo</th>
              <th className="py-2 text-left">Proposito</th>
              <th className="py-2 text-left">Duracion</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-border-subtle">
              <td className="py-2 font-mono text-xs">examsreactor:theme</td>
              <td className="py-2">Esencial (localStorage)</td>
              <td className="py-2">Recordar preferencia dark/light</td>
              <td className="py-2">Permanente hasta limpiar navegador</td>
            </tr>
            <tr className="border-b border-border-subtle">
              <td className="py-2 font-mono text-xs">__session_id</td>
              <td className="py-2">Esencial</td>
              <td className="py-2">Mantener tu sesion autenticada</td>
              <td className="py-2">30 dias</td>
            </tr>
            <tr className="border-b border-border-subtle">
              <td className="py-2 font-mono text-xs">examsreactor:consent</td>
              <td className="py-2">Esencial (localStorage)</td>
              <td className="py-2">Recordar tus elecciones de consentimiento</td>
              <td className="py-2">12 meses</td>
            </tr>
          </tbody>
        </table>

        <h2 className="mt-8 text-2xl font-bold">No usamos</h2>
        <ul>
          <li>Cookies publicitarias.</li>
          <li>Trackers de Google, Facebook, TikTok ni similares.</li>
          <li>Cookies cross-site.</li>
          <li>Fingerprinting.</li>
        </ul>

        <h2 className="mt-8 text-2xl font-bold">Como controlar las cookies</h2>
        <p>
          Puedes borrar cookies y datos de localStorage desde la configuracion de tu navegador.
          Hacerlo cerrara tu sesion y restablecera tus preferencias.
        </p>

        <hr className="my-8 border-border-subtle" />

        <p className="text-xs text-text-tertiary">
          <strong>NOTA:</strong> Borrador (RC-LEGAL-003, Sprint 15). El cookie banner granular
          se implementa en RC-LEGAL-011.
        </p>
      </div>
    </div>
  );
}
